import React from "react";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import "../App.css";

const Page404 = () => {
	return (
		<motion.section initial={{ opacity: 0 }} animate={{ opacity: 1 }} exit={{ opacity: 0 }} transition={{ ease: "linear", duration: 0.08 }} style={{ backgroundImage: `url('https://firebasestorage.googleapis.com/v0/b/space-73.appspot.com/o/error.svg?alt=media')` }}>
			<div className="error-div">
				<div className="error-text-div">
					<h4>Uh oh! I think you are lost.</h4>
					<p>It looks like the page you are looking for doesn't exist.</p>
					<Link to="/" className="btn">
						Go back home
					</Link>
				</div>
			</div>
		</motion.section>
	);
};

export default Page404;
